var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        [
          _c("v-toolbar-title", [
            _c("div", [
              _c(
                "div",
                { staticClass: "info--text" },
                [
                  _c("v-icon", { attrs: { medium: "" } }, [_vm._v("router")]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Continuous Data")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body-2" }, [
                _vm._v("\n          Summary\n        "),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.wideForm
        ? _c(
            "v-card",
            { staticClass: "card-bg-4" },
            [
              _c("ContinuousDataSummary", {
                staticClass: "mb-2",
                on: {
                  "update:timeSeries": function ($event) {
                    _vm.selectedTimeSeries = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("ContinuousSummaryGraph", {
                staticClass: "mb-2",
                attrs: {
                  id: "summaryChart",
                  station: _vm.continuousStation,
                  datasets: _vm.datasets,
                  selectedTimeSeries: _vm.selectedTimeSeries,
                },
              }),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", lg6: "" } },
                    [
                      _c("ContinuousInformation", {
                        staticClass: "mr-1",
                        attrs: { editForm: _vm.editForm },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", lg6: "" } },
                    [
                      _c("Aliases", {
                        staticClass: "ml-1",
                        attrs: { editForm: _vm.editForm },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-card",
            { staticClass: "card-bg-4" },
            [
              _c("ContinuousDataSummary", {
                staticClass: "mb-2",
                on: {
                  "update:timeSeries": function ($event) {
                    _vm.selectedTimeSeries = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("ContinuousSummaryGraph", {
                staticClass: "mb-2",
                attrs: {
                  id: "summaryChart",
                  station: _vm.continuousStation,
                  datasets: _vm.datasets,
                  selectedTimeSeries: _vm.selectedTimeSeries,
                },
              }),
              _vm._v(" "),
              _c("ContinuousInformation", {
                attrs: { editForm: _vm.editForm },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }